<template>
    <div>
        <div>
            <SignInPC v-if="isPC" />
            <SignInH5 v-else />
        </div>
    </div>
</template>
<script>
    import { enableAppShare } from '../../../common/js/APP/share';
    import SignInH5 from '../components/SignInH5New';
    import SignInPC from '../components/SignInPCNew';
    export default {
        name: 'Index',
        components: {
            SignInH5,
            SignInPC,
        },
        data() {
            return {
                isBView:'',//A版 false     B版 true
            };
        },
        created () {
            enableAppShare({
                title: '成为HR抢着挖的人是一种什么体验？',
                desc: '构建数据分析能力，成为企业抢手的高薪人才',
                imgUrl: 'https://s21.lgstatic.com/growth/activity/20210301/1614584493081.png'
            });
            // this.getPageFn()
        },
        methods: {
            // getPageFn() {
            //     let params = {
            //         pageContext: "DATA_ANALYSIS",//数据分析
            //         pageVersion: getCookie('DATA_ANALYSIS_Version') || null,
            //         pageType: getCookie('DATA_ANALYSIS_Type') || null,
            //     }
            //     fetchQueryFN(params).then(res => {
            //         if(res.state == 1) {
            //             if(res.content.hitType == 1) { //命中页面 不返回值
            //                 this.isBView = getCookie('DATA_ANALYSIS_Type') && getCookie('DATA_ANALYSIS_Type') == 2 ? 'B' : 'A';
            //             } else if (res.content.hitType == 2) { //刷新页面
            //                 this.isBView = res.content && res.content.pageType == 2 ? 'B' : 'A';
            //                 setCookie('DATA_ANALYSIS_Version', res.content.pageVersion)
            //                 setCookie('DATA_ANALYSIS_Type', res.content.pageType)
            //             } else { //未命中 走a版
            //                 this.isBView = 'A'
            //             }
            //         } else {
            //             this.isBView = 'A'  //默认a版  报错a版
            //         }
            //     }).catch(error => {
            //         this.isBView = 'A'  //默认a版  报错a版
            //     });
            // },
        },
    };
</script>